export const MAIN = '/main'
export const PRIVACY = '/privacy'
export const CONTACTS = '/contacts'